// src/data/mockData.ts

// === TIPOS PARA RESEÑAS ===
export interface Resena {
    id: number;
    nombre: string;
    modelo: string; // ✅ CORREGIDO: Ahora se llama 'modelo'
    calificacion: 1 | 2 | 3 | 4 | 5;
    texto: string;
}

// === MOCK DATA DE RESEÑAS DE CLIENTES ===
export const MOCK_RESENAS: Resena[] = [
    {
        id: 1,
        nombre: 'Andrés Pérez',
        modelo: 'Bestune T77', // ✅ CORREGIDO
        calificacion: 5,
        texto: 'El T77 es superior a cualquier competidor en su clase. Increíble la calidad y el servicio de Bestune fue de primera. ¡Muy recomendado!',
    },
    {
        id: 2,
        nombre: 'Sofía Montilla',
        modelo: 'Bestune T55', // ✅ CORREGIDO
        calificacion: 4,
        texto: 'La Bestune T55 es perfecta para mi ruta diaria al trabajo. Cómodo, económico y muy confiable. Le doy 4 estrellas solo porque me gustaría más opciones de color.',
    },
    {
        id: 3,
        nombre: 'Carlos Gámez',
        modelo: 'Bestune T99', // ✅ CORREGIDO
        calificacion: 5,
        texto: 'Viajamos por todo el país en mi T99. Es robusto, amplio y aguanta cualquier carretera. Un carro de calidad premium.',
    },
];